import React from "react";
import { motion } from "framer-motion";
import {
  faReact,
  // faGoogle,
  // faNodeJs,
} from "@fortawesome/free-brands-svg-icons";
import {
  faMobileScreenButton,
  faCloud,
  faRobot,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const services = [
  {
    title: "Frontend Development",
    icon: faReact,
    color: "#61DBFB",
    desc: "Build responsive, fast and scalable web applications using React.js, Next.js, TypeScript and Tailwind CSS.",
    tags: ["React", "Next.js", "TypeScript", "Tailwind"],
  },
  {
    title: "Mobile App Development",
    icon: faMobileScreenButton,
    color: "#22C55E",
    desc: "Develop production-ready React Native apps with Expo, offline support, push notifications and Play Store deployment.",
    tags: ["React Native", "Expo", "Firebase", "AdMob"],
  },
  {
    title: "Backend & Cloud",
    icon: faCloud,
    color: "#F59E0B",
    desc: "Create secure APIs with Node.js, integrate Firebase, Cloudflare Workers, KV and scalable backend services.",
    tags: ["Node.js", "GCP", "AWS", "Cloudflare", "Firebase", "REST API"],
  },
  {
    title: "AI & Automation",
    icon: faRobot,
    color: "#A855F7",
    desc: "Integrate Gemini AI, automate notifications, admin dashboards and intelligent product workflows.",
    tags: ["Gemini AI", "OpenAI", "Automation", "FCM"],
  },
];

export default function Service() {
  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-[450px] w-[450px] rounded-full bg-purple-500/20 blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-pink-500/20 blur-[120px]" />
        <div className="absolute top-16 right-1/4 h-[220px] w-[220px] rounded-full bg-cyan-400/20 blur-[100px]" />
      </div>

      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.04)_1px,transparent_1px)] bg-[size:40px_40px]" />
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />

      <div className="relative mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <p className="uppercase tracking-[0.35em] text-yellow-400 font-semibold">
            What I Do
          </p>
          <h2 className="mt-4 text-5xl font-bold text-white">
            My <span className="text-yellow-400">Services</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-gray-400">
            I build modern web and mobile products from idea to deployment with
            clean UI, scalable architecture and cloud-powered features.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-4">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, scale: 1.02 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="group rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-7 hover:border-yellow-400/40 hover:bg-white/10"
            >
              <div
                className="flex h-16 w-16 items-center justify-center rounded-2xl"
                style={{
                  background: `${service.color}20`,
                  border: `1px solid ${service.color}55`,
                }}
              >
                <FontAwesomeIcon
                  icon={service.icon}
                  style={{ color: service.color }}
                  className="text-3xl"
                />
              </div>

              <h3 className="mt-6 text-2xl font-semibold text-white">
                {service.title}
              </h3>

              <p className="mt-4 text-sm leading-7 text-gray-400">
                {service.desc}
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {service.tags.map((tag) => (
                  <span
                    key={tag}
                    className="rounded-full border border-yellow-400/20 bg-yellow-400/10 px-3 py-1 text-xs text-yellow-300"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
